import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=592bc0e8&scoped=true&"
import script from "./Ads.vue?vue&type=script&lang=js&"
export * from "./Ads.vue?vue&type=script&lang=js&"
import style0 from "./Ads.vue?vue&type=style&index=0&id=592bc0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592bc0e8",
  null
  
)

export default component.exports